"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconBell = function SvgIconBell(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "bell icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Bell Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M34.417 21.526v9.133l3.632 3.654v1.826H9v-1.827l3.631-3.653v-9.133c0-5.626 2.96-10.302 8.17-11.544V8.74A2.728 2.728 0 0123.524 6a2.728 2.728 0 012.724 2.74v1.242c5.192 1.242 8.17 5.937 8.17 11.544zm-7.262 16.44c0 2.01-1.634 3.653-3.63 3.653-2.016 0-3.632-1.644-3.632-3.653h7.262z",
    clipRule: "evenodd"
  }));
};

var _default = SvgIconBell;
exports.default = _default;